import * as CONST from 'Reducers/Clients/const'

/**
 * Get client by id
 * @returns Object
 */
export function getClientById(id) {
  return {
    type: CONST.GET_CLIENT_BY_ID,
    payload: {
      id,
    },
  }
}

/**
 * Reset client by id
 * @returns Object
 */
export function resetClientById() {
  return {
    type: CONST.RESET_CLIENT_BY_ID,
  }
}

/**
 * Update client by id
 *
 * @param callbacks
 * @param clientId
 * @param payload
 * @returns {{type, callbacks: *, clientId: *, payload: *}}
 */
export function updateClientById(callbacks, clientId, payload) {
  return {
    type: CONST.UPDATE_CLIENT_BY_ID,
    callbacks,
    clientId,
    payload,
  }
}

/**
 * Create client
 *
 * @param callbacks
 * @param payload
 * @returns {{type, callbacks: *, payload: *}}
 */
export function createClient(callbacks, payload) {
  return {
    type: CONST.CREATE_CLIENT,
    callbacks,
    payload,
  }
}

/**
 * Get clients
 * @returns Object
 */
export function getClients() {
  return {
    type: CONST.GET_CLIENTS,
  }
}

/**
 * Set clients filter by status value
 * @returns Object
 */
export function setStatusFilter(statusFilter) {
  return {
    type: CONST.SET_STATUS_FILTER,
    statusFilter,
  }
}
